module.exports = __webpack_public_path__ + "static/media/collection-cover.8dcf17fd.jpg";